import React from "react";

const CircleArrowRight = ({ color = "#254FE2" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM14.7806 12.5306L11.0306 16.2806C10.9609 16.3503 10.8782 16.4056 10.7872 16.4433C10.6961 16.481 10.5986 16.5004 10.5 16.5004C10.4015 16.5004 10.3039 16.481 10.2128 16.4433C10.1218 16.4056 10.0391 16.3503 9.96938 16.2806C9.89969 16.2109 9.84442 16.1282 9.8067 16.0372C9.76899 15.9461 9.74958 15.8485 9.74958 15.75C9.74958 15.6515 9.76899 15.5539 9.8067 15.4628C9.84442 15.3718 9.89969 15.2891 9.96938 15.2194L13.1897 12L9.96938 8.78063C9.82865 8.6399 9.74959 8.44903 9.74959 8.25C9.74959 8.05098 9.82865 7.86011 9.96938 7.71938C10.1101 7.57865 10.301 7.49959 10.5 7.49959C10.699 7.49959 10.8899 7.57865 11.0306 7.71938L14.7806 11.4694C14.8504 11.539 14.9057 11.6217 14.9434 11.7128C14.9812 11.8038 15.0006 11.9014 15.0006 12C15.0006 12.0986 14.9812 12.1962 14.9434 12.2872C14.9057 12.3783 14.8504 12.461 14.7806 12.5306Z"
      fill={color}
    />
  </svg>
);

export default CircleArrowRight;
